import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import Header from "./Header";
import Sidebar from "./SideBar";
import FloatingChatwidgetIcon from "./FloatingIcon";
import FMChatWidget from "../tabs/FMChatWidget/index";

import { setHideChatwidget, setShowChatwidget } from "../../state/actions/bot";
import { clearChatwidgetNotifications, updateChatwidgetNotifications } from "../../state/actions/chats";
import { useLocation } from "react-router-dom";
import { getPageName } from "../../utils/general";
import PhoneDevice from "../../pages/Telephony/PhoneDevice";
import Home from "../../pages/Home";
import SpinnetView from "../common/SpinnetView";
import { getAuthData, getSessinIdFromLS } from "../../services/storage/LocalStorage";
import config from "../../utils/config/config";
import { appType } from "../../utils/config/configHelpers";
import { createConversationId } from "../../utils/conversationUtils";
import SpinnetMicroApps from "../common/SpinnetMicroApps";
import { removeSpinnetMicroAppsScript } from "../../utils/ChatbotScriptHelpers";

const Layout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [updatedIchatwidgetNotifications, setUpdatedChatwidgetNotifications] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = getPageName();

  const isAnonymousUser = useSelector((state) => state.user.isAnonymousUser);
  const isSideBar = useSelector((state) => state.layout.isSideBar);
  const initialchatwidgetNotifications = useSelector((state) => state.chats.chatwidgetNotifications);
  const selectedBotDetails = useSelector((state) => state.domain.selectedBotDetails);
  const isOpenChatWidget = useSelector((state) => state.bot.isOpenChatWidget);
  const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);
  const isOneToOneChat = useSelector((state) => state.chats.oneToOneChat);
  const connectionId = localStorage.getItem("connectionId");
  const refreshToken = localStorage.getItem("refreshToken");


  const { selectedBotId, defaultHomePageBotId } = useSelector((state) => state.domain);
  const botWaitLoader = useSelector((state) => state.loader.botWaitLoader);
  const userDetail = getAuthData();
  const userData = userDetail.user || {}
  const selectedConversation = useSelector((state) => state.chats.selectedConversation);
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const homeClick = useSelector((state) => state.layout.homeClick);
  // const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);
  // const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const domainList = useSelector((state) => state?.domain?.domains);
  const botSubscriptions = useSelector((state) => state?.user?.botSubscriptions);
  // const refreshToken = localStorage.getItem("refreshToken");
  // const connectionId = localStorage.getItem("connectionId");
  // const dispatch = useDispatch();
  const sessionId = getSessinIdFromLS();

  useEffect(() => {
    if (isDefaultHomePageBot) {
      removeSpinnetMicroAppsScript();
    }
  }, [isDefaultHomePageBot]);

  useEffect(() => {
    dispatch(clearChatwidgetNotifications());
  }, [location.pathname]);

  useEffect(() => {
    if (initialchatwidgetNotifications) {
      const filterNoti = initialchatwidgetNotifications.filter((msg) => msg.bot === selectedBotDetails?.botId);
      setUpdatedChatwidgetNotifications(filterNoti);
    }
  }, [initialchatwidgetNotifications, selectedBotDetails]);

  // Handle screen resize for mobile check
  useEffect(() => {
    if (pathname !== "Home") {
      dispatch(setHideChatwidget());
    }

    const checkScreenSize = () => setIsMobile(window.innerWidth < 1024);
    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);


  // Update notification count
  useEffect(() => {
    const count = updatedIchatwidgetNotifications?.filter((msg) => msg.show)?.length || 0;
    setNotificationCount(count);
  }, [updatedIchatwidgetNotifications]);

  useEffect(() => {
    if (isOpenChatWidget) {
      if (typeof window.isOpenChatWidget === "function")
        window.isOpenChatWidget(isOpenChatWidget);
    }
  }, [isOpenChatWidget]);


  const handleChatWidgetClick = () => {
    dispatch(setShowChatwidget());
    dispatch(clearChatwidgetNotifications());
  };


  const handleCloseFloatMessage = (msg) => {
    if (!msg?.messageId) return;
    const updatedList = updatedIchatwidgetNotifications.filter((notification) =>
      notification.messageId !== msg.messageId
    );
    dispatch(updateChatwidgetNotifications(updatedList));
  };


  return (
    <div className="min-h-screen bg-purple-light-bg">
      <Sidebar />

      <div
        className="h-[100vh] flex flex-col transition-all duration-300 ease-in-out"
        style={{ paddingLeft: isMobile || isSideBar ? "76px" : "211px" }}
      >
        <Header />
        {/* ------Spinnet Here--- */}
          <div className={`relative px-3 spinnet-container py-3 ${selectedDomain && isDefaultHomePageBot && !selectedBotId && !selectedBotDetails ? '' : 'hidden'}`}>
            <SpinnetView
              baseUrl={isDefaultHomePageBot ? config.defaultHomePagebaseUrl : selectedBotDetails?.customFrontEnd}
              botId={selectedBotId ? selectedBotId : defaultHomePageBotId }
              email={userData?.emailAddress}
              mobileSession={sessionId || userDetail?.auth?.sessionId}
              appType={appType}
              platform="web"
              conversationId={
                isDefaultHomePageBot
                  ? defaultHomePageBotId
                    ? createConversationId(userData.userId, defaultHomePageBotId)
                    : ""
                  : selectedConversation?.conversationId ? selectedConversation.conversationId : createConversationId(userData.userId, defaultHomePageBotId)
              }
              userDomain={selectedDomain}
              refreshToken={refreshToken}
              connectionId={connectionId}
              isLoading={botWaitLoader}
              isDefaultHomePageBot={isDefaultHomePageBot}
              botSubscriptions={botSubscriptions}
              selectedBotId={selectedBotId}
            />
          </div>

          {selectedDomain && ((selectedConversation && selectedBotDetails?.customFrontEnd) && !isDefaultHomePageBot) &&
           <div className="relative px-3 spinnet-container py-3">
            <SpinnetMicroApps
              baseUrl={isDefaultHomePageBot ? config.defaultHomePagebaseUrl : selectedBotDetails?.customFrontEnd}
              botId={selectedBotId ? selectedBotId : defaultHomePageBotId }
              email={userData?.emailAddress}
              mobileSession={sessionId || userDetail?.auth?.sessionId}
              appType={appType}
              platform="web"
              conversationId={
                isDefaultHomePageBot
                  ? defaultHomePageBotId
                    ? createConversationId(userData.userId, defaultHomePageBotId)
                    : ""
                  : selectedConversation?.conversationId ? selectedConversation.conversationId : createConversationId(userData.userId, defaultHomePageBotId)
              }
              userDomain={selectedDomain}
              refreshToken={refreshToken}
              connectionId={connectionId}
              isLoading={botWaitLoader}
              isDefaultHomePageBot={isDefaultHomePageBot}
              botSubscriptions={botSubscriptions}
              selectedBotId={selectedBotId}
            />
          </div>}

        {/* Main Content Area */}
        <div className={`grid grid-cols-12 overflow-auto h-full pb-2 w-full ${homeClick ? "" : "spinnet-module"}`}>
          <div
            className={`${isOpenChatWidget
              ? "col-span-8 xl:col-span-8 2xl:col-span-9"
              : "col-span-12"
              } flex flex-col overflow-auto hide-scrollbar`}
          >
            <main className="sm:px-4 sm:py-4 py-2 px-2 h-full overflow-auto hide-scrollbar">
              {children}
            </main>
          </div>
          {/* Chat Widget Side Panel */}
          {!isAnonymousUser && <PhoneDevice />}
          <div
            className={`transition-all duration-300 ease-in-out relative ${isOpenChatWidget
              ? "col-span-4 xl:col-span-4 2xl:col-span-3 flex justify-center align-middle pe-4"
              : "hidden"
              }`}
          >
            {!isAssistantBotOpen && <FMChatWidget refreshToken={refreshToken} connectionId={connectionId} />}

          </div>
        </div>
      </div>


      {/* Floating Chat Icon */}
      {!isOpenChatWidget &&
        !isAssistantBotOpen &&
        !selectedBotDetails?.customFrontEnd &&
        !selectedBotDetails?.systemBot &&
        !isDefaultHomePageBot &&
        !selectedBotDetails?.conversational &&
        !isOneToOneChat &&
        location.pathname === "/app/chats" &&
        (
          <FloatingChatwidgetIcon
            notificationCount={notificationCount}
            selectedBotDetails={selectedBotDetails}
            chatwidgetNotifications={updatedIchatwidgetNotifications}
            handleCloseFloatMessage={handleCloseFloatMessage}
            handleChatWidgetClick={handleChatWidgetClick}
          />
        )}
    </div>
  );
};

export default Layout;
